import { combineReducers } from "redux";
import { authReducer } from "./Reducers/auth.reducer";
import { errorReducer } from "./Reducers/error.reducer";
import { catelogReducer } from "./Reducers/catelog.reducer";
import { customerReducer } from "./Reducers/customer.reducer";
import { orderReducer } from "./Reducers/order.reducer";
import extensionReducer from "./Reducers/extensions.reducer";

const rootReducer = combineReducers({
  authReducer,
  errorReducer,
  catelogReducer,
  customerReducer,
  orderReducer,
  extensionReducer,
});

export default rootReducer;
